module.exports = "<div class=\"panel panel-primary\">\n    <div class=\"panel-heading\">Lunch Settings</div>\n\n\n    <div class=\"panel-body\">\n        <button class=\"btn btn-primary\" (click)=\"addNewSetting()\">Add New Config</button>\n        <br>\n        <br>\n        <div class=\"row\" *ngFor=\"let setting of settingsData; index as i;\">\n            <app-setting-form [setting]=\"setting\"></app-setting-form>\n        </div>\n        \n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/setting/setting.component.html
// module id = ./src/app/pages/setting/setting.component.html
// module chunks = main